import api from '../../helpers/axiosHelper';
import { API_ROOT_URL } from '../../helpers/api';

const MODEL_PERMISSIONS_URL = '/visual_scale/authorization/api/v1/model-permissions/';

export const IMAGINE_AI_PERMISSIONS = {
  IMAGINE_AI_V2: 'lf_invite_internal_can_use_imagine_ai_v2',
  GEMINI_PROMPT_INTENT: 'lf_invite_internal_can_use_gemini_prompt_intent_model',
};

export const getModelPermissions = () =>
  api()
    .root(API_ROOT_URL)
    .get(MODEL_PERMISSIONS_URL)
    .requestConfig({ messages: { hideTost: true } })
    .success((res) => res)
    .error((err) => {
      throw err;
    })
    .send();
